import { createContext, useContext } from "react";
import { RelevantTenantInfo } from "routes/Admin/Accounts/Members/Helpers";
import { TenantType } from "generated/graphql.schema";
import { CombinedError } from "urql";
import { TenantsListQuery } from "generated/graphql";

export const placeholderTenant: RelevantTenantInfo = {
  id: "",
  name: "",
  type: TenantType.Enterprise
};

export type SelectedTenantValues = {
  tenant: RelevantTenantInfo | undefined;
  fetching: boolean;
  error: CombinedError | undefined;
  refetch: () => void;
  tenants: {
    tenants: TenantsListQuery | undefined;
    fetching: boolean;
    error: CombinedError | undefined;
  };
};

export const SelectedTenantContext = createContext<SelectedTenantValues>({
  tenant: undefined,
  fetching: false,
  error: undefined,
  refetch: () => {},
  tenants: {
    tenants: undefined,
    fetching: false,
    error: undefined
  }
});

export const SelectedTenantTypeContext = createContext<TenantType | undefined>(
  undefined
);

export const useTenantId = () => {
  const { tenant } = useContext(SelectedTenantContext);
  return tenant?.id ?? "";
};
